import { render, staticRenderFns } from "./Tutorials.vue?vue&type=template&id=235614b5"
import script from "./Tutorials.vue?vue&type=script&lang=ts"
export * from "./Tutorials.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports